// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__1WZly","loadingShrink":"PageLoading_loadingShrink__1A0oR"};